<template>
  <div class="container">
    <h2>Panel de Administración</h2>

    <!-- Banners: admin y editor -->
    <div class="row justify-content-center" v-if="['admin','editor'].includes(myuser.role)">
      <SliderEdit></SliderEdit>
    </div>

    <!-- Noticias: admin y editor -->
    <div class="row justify-content-center mb-4" v-if="['admin','editor'].includes(myuser.role)">
      <NewsTable :news="news" :loading="loading.table" @get-data="getNews"></NewsTable>
    </div>

    <!-- Usuarios: solo admin -->
    <div class="row justify-content-center mb-4" v-if="myuser.role === 'admin'">
      <UserTable :myuser="myuser"></UserTable>
    </div>

    <!-- Suscripciones: solo admin -->
    <div class="container mb-4" v-if="myuser.role === 'admin'">
      <div class="justify-content-center d-flex">
        <a href="/subscriptions" target="_blank" class="btn btn-primary">
          <i class="fal fa-download"></i>
          <span class="ms-1">Descargar Suscripciones</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import NewsTable from './NewsTable.vue'
import UserTable from './UserTable.vue'
import SliderEdit from './Slider.vue'
export default {
  name: 'Dashboard',
  components: { NewsTable, SliderEdit, UserTable },
  data() {
    return {
      data: {},
      news: {},
      myuser: {},
      loading: {
        table: false,
      },
    }
  },
  mounted() {
    this.getNews()
    this.getMyuser()
  },
  methods: {
    getNews(page = 1) {
      const self = this
      self.loading.table = true
      axios
        .get('/admin/news', {
          params: {
            page: page,
          },
        })
        .then((res) => {
          if (res.data.success) {
            self.news = res.data.data
          }
        })
        .finally(() => {
          self.loading.table = false
        })
    },
    getMyuser() {
      const self = this
      self.loading.table = true
      axios
        .get('/admin/myuser')
        .then((res) => {
          if (res.data.success) {
            self.myuser = res.data.data
          }
        })
        .finally(() => {
          self.loading.table = false
        })
    },
  },
}
</script>
